/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['rest/routing/matrixFactory', 'rest/request/singleRequestServiceFactory', 'endpoints',
    'rest/request/batchRequestServiceFactory', 'apiKeyNames'],
function(matrixFactory, singleRequestServiceFactory, endpoints, batchRequestServiceFactory, ApiKeyNames) {
    'use strict';

    var maxNoOfElementsInBatchRequest = 100,
        routingKeyName = ApiKeyNames.routing;

    return {
        calculateRoute: singleRequestServiceFactory(endpoints.routing, routingKeyName),

        calculateReachableRange: singleRequestServiceFactory(endpoints.reachableRange, routingKeyName),

        batch: batchRequestServiceFactory(maxNoOfElementsInBatchRequest,
            { batchSync: endpoints.batchSyncRouting, batch: endpoints.batchRouting,
              single: endpoints.batchRoutingQuery}, routingKeyName),

        batchReachableRange: batchRequestServiceFactory(maxNoOfElementsInBatchRequest,
            { batchSync: endpoints.batchSyncRouting, batch: endpoints.batchRouting,
              single: endpoints.batchReachableRangeQuery}, routingKeyName),

        matrix: matrixFactory(maxNoOfElementsInBatchRequest)
    };
});



// WEBPACK FOOTER //
// ./rest/routing.js